import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Typography from '@mui/material/Typography';
import Loading from 'components/system/Loading';
import Page from 'components/system/Page';
import Paper from 'components/system/Paper';
import useTeamMembers from 'hooks/useTeamMembers';
import useTeamDetails from 'hooks/useTeamDetails';
import useAccountStore from 'store/accountStore';
import useTeamStore from 'store/teamStore';
import colors from 'styles/colors';
import Container from '@mui/material/Container';
import TeamSettingsRow from './TeamSettingsRow';

const columns = [
  { key: 'displayName', label: 'Name' },
  { key: 'email', label: 'Email' },
  { key: 'teamRole', label: 'Role' },
];

const TeamSettings = () => {
  const { teamId } = useAccountStore((state) => ({
    teamId: state.activeAccount.teamId,
  }));

  const {
    name, members, error, isLoading,
  } = useTeamStore((state) => ({
    members: state.members.list,
    isLoading: state.members.isLoading,
    error: state.members.error,
    name: state.name,
  }));

  useTeamDetails(teamId);

  const { refetch: refetchTeamMembers } = useTeamMembers(teamId);

  let content = null;

  if (isLoading) {
    content = <Loading />;
  } else if (error && error.response?.status === 401) {
    content = (
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          width: '100%',
          textAlign: 'center',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box>
          <Typography variant="h5" color={colors.text.primary}>
            Team Not Found
          </Typography>
          <Typography variant="body2" sx={{ color: colors.text.tetriary, padding: '20px 0' }}>
            Sorry, You don’t belong to any team.
          </Typography>
        </Box>
      </Box>
    );
  } else if (error) {
    content = (
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          width: '100%',
          textAlign: 'center',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box>
          <Typography variant="body2" sx={{ color: colors.text.tetriary, padding: '20px 0' }}>
            Something went wrong. Please try again later.
          </Typography>
        </Box>
      </Box>
    );
  } else {
    content = (
      <Table className="teamSettings" enableRowActions>
        <TableHead>
          <TableRow>
            {
              columns.map(({ label }) => (
                <TableCell key={label} align="left">{label}</TableCell>
              ))
            }
            <TableCell align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {members?.map((member) => (
            <TeamSettingsRow
              key={member.userId}
              member={member}
              columns={columns}
              updateTeamMembers={refetchTeamMembers}
            />
          ))}
        </TableBody>
      </Table>
    );
  }

  return (
    <Container>
      <Page title={`Team ${name}`}>
        <Paper>
          {!error && (
            <Typography variant="h6" sx={{ color: colors.text.primary }}>
              Team Members
            </Typography>
          )}
          <Grid container sx={{ padding: 0, overflowX: 'auto' }}>
            <Grid item xs={12}>
              {content}
            </Grid>
          </Grid>
        </Paper>
      </Page>
    </Container>
  );
};

export default TeamSettings;
